import * as types from "./actiontypes"

const initialState = {
    employeeData: null,
    isLoading: false,
    isError: false
}

export const Employeereducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_EMPLOYEE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.GET_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                employeeData: payload
            }

        case types.GET_EMPLOYEE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
                // massage: ""
            }

        case types.CREATE_EMPLOYEE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }

        case types.CREATE_EMPLOYEE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                employeeData: payload
            }

        case types.CREATE_EMPLOYEE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            }

        default:
            return state
    }
}